<template lang="html">
  <div class="comments-new">
    <div class="scroll-bar" :style="scrollBarStyles">
      <div class="comment" v-for="(comment, index) in items">
        <div class="comments-heading">
          <div class="name">{{ comment.name }}</div>
          <img :src="comment.rating" width="101px" height="15px">
        </div>
        <div class="text">{{ comment.text }}</div>
      </div>
    </div>

    <div class="pagination">
        <div
          v-for="slide, i in items"
          key="i"
          class="circle"
          :class="{
            'active': i == currentSlide
          }">
            &nbsp;
        </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      currentSlide: 0,
      comments: [
       {
          'name': 'Alexander',
          'text': 'Great app! It realy helps to become better.'
        },
        {
          'name': 'Michael',
          'text': 'OK! Have beed using it for more then three months!'
        },
        {
          'name': 'Emily',
          'text': 'Using this app for a while.Love it!'
        },
      ]
    }
  },
  mounted() {
    setInterval(() => {
      this.currentSlide = (this.currentSlide + 1) % this.comments.length;
    }, 2000);
  },
  computed: {
    scrollBarStyles() {
      return {
        transform: `translateX(${this.currentSlide * -window.innerWidth}px)`,
      };
    },
  }
}
</script>

<style lang="sass" scoped>
.comments-new
  display: block
  width: 100%
  height: 130px
  position: relative
  flex-shrink: 0
  overflow: hidden
  &::-webkit-scrollbar
    display: none
  .comments-heading
    display: flex
    justify-content: space-between
    align-items: center
    width: 100%
    img
      flex-shrink: 0
  .scroll-bar
    position: absolute
    left: 0
    width: max-content
    display: flex
    flex-direction: row
    padding: 6px 0
    transition: transform .5s linear
    .comment
      display: flex
      flex-direction: column
      width: 100vw
      justify-content: center
      align-items: center
      gap: 12px
      padding-left: 1.5rem
      padding-right: 1.5rem
      box-sizing: border-box
    .name
      font-weight: 700
      font-size: 1.125rem
      line-height: 1.5rem
      color: #000000
    .text
      font-size: .75rem
      line-height: .875rem
      font-weight: 400
      text-align: left
      color: #8D8D8D

.pagination
  position: absolute
  bottom: 0
  left: 50%
  transform: translate(-50%)
  display: flex
  flex-direction: row
  gap: 6px

  .circle
    width: 10px
    height: 10px
    border-radius: 10px
    background-color: #E3EDFF
    flex-shrink: 0

    &.active
      background-color: #4285F7
</style>